import React, { useState, useRef } from 'react';
import { Image } from 'antd';
import { createPortal } from 'react-dom';

/**
 * Componente che mostra un'immagine con effetto zoom al passaggio del mouse
 * @param {string} src - URL dell'immagine
 * @param {string} alt - Testo alternativo dell'immagine
 * @param {object} style - Stile dell'immagine in miniatura
 * @param {function} onLoad - Funzione da chiamare quando l'immagine è caricata
 * @returns {JSX.Element}
 */
// Creiamo un elemento DOM esterno per il portale una sola volta
let portalRoot = null;
if (typeof window !== 'undefined') {
  // Verifica se il portale esiste già
  portalRoot = document.getElementById('zoom-portal-root');

  // Se non esiste, crealo
  if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.id = 'zoom-portal-root';
    portalRoot.style.position = 'fixed';
    portalRoot.style.top = '0';
    portalRoot.style.left = '0';
    portalRoot.style.width = '100%';
    portalRoot.style.height = '100%';
    portalRoot.style.pointerEvents = 'none';
    portalRoot.style.zIndex = '2147483647'; // Il massimo zIndex possibile
    document.body.appendChild(portalRoot);
  }
}

const HoverImageZoom = ({ src, alt, style, onLoad, onError }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  // Funzione per gestire il movimento del mouse
  const handleMouseMove = (e) => {
    // Calcola la posizione del mouse rispetto alla finestra
    setMousePosition({
      x: e.clientX,
      y: e.clientY
    });
  };

  // Stile per il contenitore dell'immagine
  const containerStyle = {
    position: 'relative',
    cursor: 'zoom-in',
    ...style
  };

  return (
    <div
      ref={containerRef}
      style={containerStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onMouseMove={handleMouseMove}
    >
      <img
        src={src}
        alt={alt}
        style={{
          ...style,
          objectFit: 'contain'
        }}
        onLoad={onLoad}
        onError={onError}
      />

      {isHovered && portalRoot && createPortal(
        <div
          style={{
            position: 'fixed',
            top: mousePosition.y < window.innerHeight / 2 ? mousePosition.y + 20 : mousePosition.y - 320,
            left: mousePosition.x < window.innerWidth / 2 ? mousePosition.x + 20 : mousePosition.x - 320,
            backgroundColor: 'white',
            padding: '10px',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
            pointerEvents: 'none'
          }}
        >
          <Image
            src={src}
            alt={alt}
            preview={false}
            width={300}
            height={300}
            style={{ objectFit: 'contain' }}
          />
        </div>,
        portalRoot
      )}
    </div>
  );
};

export default HoverImageZoom;
